module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"top10":"TOP10","top20":"TOP20","bottom10":"BOTTOM10","bottom20":"BOTTOM20","all":"ALL","ranking":"Ranking","tooltip":"The ranking of individual stores can be displayed by either actual value or variance. Choose the number of stores to be displayed by the Top/Bottom dropdown lists.","store":"Store","store_code":"Store Code","value":"Value","variation":"Variation"}}')
  delete Component.options._Ctor
}
